const SYSTEM_PERMISSIONS = {
  CAN_RECEIVE_ADDITIONAL_ROLES: 'CAN_RECEIVE_ADDITIONAL_ROLES',
  MANAGE_ADMISSIONS: 'MANAGE_ADMISSIONS_FOR_ASSOC_COLLEGE',
  PERFORM_ADMISSIONS_TASKS: 'PERFORM_ADMISSIONS_TASKS_FOR_ASSOCIATED_COLLEGE',
  PERFORM_VISIT_MANGEMENT_TASKS: 'PERFORM_VISIT_MANAGEMENT_TASKS_FOR_ASSOCIATED_COLLEGE',
  VIEW_COLLEGE_WALL: 'VIEW_ANY_COLLEGE_WALL',
  PERFORM_COLLEGE_SEARCH: 'PERFORM_COLLEGE_SEARCH',
  MANAGE_COLLEGE_CONTENT: 'MANAGE_COLLEGE_CONTENT',
  MANAGE_COLLEGE_OUTREACH_MESSAGES: 'MANAGE_COLLEGE_OUTREACH_MESSAGES',
  VIEW_ASSOCIATED_COLLEGE_DETAIL: 'VIEW_ASSOCIATED_COLLEGE_DETAIL',
  VIEW_COLLEGE_ENGAGEMENT_METRICS: 'VIEW_COLLEGE_ENGAGEMENT_METRICS',
  MANAGE_CRM_UPLOADS: 'MANAGE_CRM_UPLOADS_FOR_ASSOC_COLLEGE',
  MANAGE_COLLEGE_APPLICATION_ROUNDS: 'MANAGE_COLLEGE_APPLICATION_ROUNDS',
  TEST_COLLEGE_APPLICATION: 'TEST_COLLEGE_APPLICATION',
  VIEW_APPLICANTS: 'VIEW_APPLICANTS',
} as const

export default SYSTEM_PERMISSIONS
type SystemPermissions = typeof SYSTEM_PERMISSIONS
export type PermissionValue = SystemPermissions[keyof SystemPermissions]
